import { Directive } from '@angular/core';

@Directive({
    selector: '[appClickPopover]',
})
export class ClickPopoverDirective {
    constructor() {}
}
